import React from 'react'
import styled from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import { IImage } from '../../../graphql/types'
import { Hero } from './Hero'

const StyledImage = styled(GatsbyImage)`
  height: 100%;
  width: 100%;
`

export type CategoryPageHeroProps = {
  backgroundColor: string
  img: IImage
  title: string
}

export const CategoryPageHero = ({
  backgroundColor,
  img,
  title,
}: CategoryPageHeroProps) => {
  return (
    <Hero backgroundColor={backgroundColor} title={title} isSingleImageHero>
      <StyledImage
        image={img.image.gatsbyImageData}
        alt={title}
        objectFit="contain"
        objectPosition="cover"
      />
    </Hero>
  )
}
